import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';
import { WalletConnectDialogComponent } from '../../pages/components/wallet-connect-dialog/wallet-connect-dialog.component';
import { environment } from 'src/environments/environment';
import { Web3Service } from './web3.service';
import { CommanSubscribeService } from './comman-subscribe.service';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class MetamaskService {
  private walletIdSubject = new BehaviorSubject<string>(null);
  walletId$ = this.walletIdSubject.asObservable();
  private isDialogOpen = false;

  constructor(
    private dialog: MatDialog,
    private web3service: Web3Service,
    private storageService: StorageService,
    private commanService: CommanSubscribeService
  ) {}

  async initializeWallet(isLoggedIn: boolean) {
    if (!isLoggedIn) return;

    const storedWalletId = localStorage.getItem('WalletId');
    if (storedWalletId) {
      this.walletIdSubject.next(storedWalletId);
    }

    try {
      await this.connectToWallet();
    } catch (error) {
      console.error('Error initializing wallet:', error);
    }
  }

  private async connectToWallet() {
    this.web3service.setNetwork(environment.clientDetails.network_name);
    
    try {
      const isweb3 = await this.web3service.checkAndInstantiateWeb3();
      
      if (isweb3 === 'connected') {
        await this.web3service.setContract();
        await this.web3service.connectAccount();
        
        await this.getAccountAddress();
      }
    } catch (error) {
      if (!this.isDialogOpen) {
        this.isDialogOpen = true;
        const dialogRef = this.dialog.open(WalletConnectDialogComponent, {
          panelClass: 'app-consumer-sign-in',
          hasBackdrop: true,
          disableClose: true,
          data: {
            text: 'Please install MetaMask to claim tokens',
          }
        });

        dialogRef.afterClosed().subscribe(() => {
          this.isDialogOpen = false;
        });
      }
    }
  }

  private async getAccountAddress() {
    try {
      const accounts = await window.ethereum.request({ 
        method: 'eth_requestAccounts' 
      });
      const walletId = accounts[0];
      await this.commanService.getAccountBalance(walletId);
      localStorage.setItem('WalletId', walletId);
      this.walletIdSubject.next(walletId);
    } catch (error) {
      console.error('Error getting account address:', error);
    }
  }


setupVisibilityListener() {
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) {
        const isLoggedIn = Boolean(this.commanService.userInfo?.access_token);
        const walletId = localStorage.getItem('WalletId');
        const isAffiliateUser = this.storageService.getItem("isAffiliateUser");
        if (isLoggedIn && !walletId && isAffiliateUser) {
          window.location.reload();
        }
      }
    });
  }
}